export const REPORT_STATUS_TYPES = ['queued', 'in_progress', 'completed', 'failed', 'canceled'] as const
export const REPORT_STATUS_LABELS: Record<(typeof REPORT_STATUS_TYPES)[number], string> = {
	queued: 'Queued',
	in_progress: 'In Progress',
	completed: 'Completed',
	failed: 'Failed',
	canceled: 'Canceled',
} as const

// Matches client-frontend/router.js MODES values — the solution a litmus report was created
// under, persisted on report_metadata.mode so permission checks can be scoped to it.
export const LITMUS_REPORT_MODES = ['sigops', 'safety', 'mobility'] as const
export type LitmusReportMode = (typeof LITMUS_REPORT_MODES)[number]

export const OD_REPORT_TYPES = ['od_flow_matrix', 'od_selected_link'] as const
export const OD_REPORT_TYPE_LABELS: Record<OriginDestinationReportType, string> = {
	od_flow_matrix: 'Origin Destination',
	od_selected_link: 'Link Analysis',
} as const

// The value itself doubles as the label shown in the UI and the value persisted on a report's
// project_type — there's no separate key.
export const LIT_REPORT_PROJECT_TYPES = [
	'Signal Retiming',
	'Detection Upgrade',
	'Controller Upgrade',
	'Speed Study',
	'Workzone',
] as const

// Modes match client-frontend/router.js MODES values. Project types with no entry here are
// treated as a user-added custom type, not one of the default catalog's, and aren't mode-gated.
export const LIT_REPORT_PROJECT_TYPE_MODES: Record<LitmusReportProjectType, string[]> = {
	'Signal Retiming': ['sigops'],
	'Detection Upgrade': ['sigops'],
	'Controller Upgrade': ['sigops'],
	'Speed Study': ['mobility'],
	Workzone: ['mobility'],
} as const

export const SELECTED_STATUS_TYPES = ['', 'queued', 'in_progress', 'completed', 'failed_canceled'] as const
export const SELECTED_STATUS_TYPE_LABELS: Record<SelectedStatusType, string> = {
	'': 'All Reports',
	queued: 'Queued',
	in_progress: 'In Progress',
	completed: 'Completed',
	failed_canceled: 'Failed / Canceled',
}

export const DATE_RANGE_TYPES = ['today', '7d', '30d', '6m', 'cur_year', 'custom'] as const
export const DATE_RANGE_TYPE_LABELS: Record<DateRangeType, string> = {
	today: 'Today',
	'7d': 'Previous 7 days',
	'30d': 'Previous 30 days',
	'6m': 'Previous 6 months',
	cur_year: `This year (${new Date().getFullYear()})`,
	custom: 'Custom date range',
}

export type ReportStatusType = (typeof REPORT_STATUS_TYPES)[number]
export type OriginDestinationReportType = (typeof OD_REPORT_TYPES)[number]
// Persisted/validated as a free string so user-added custom project types (see report-metadata-form)
// remain valid alongside the default catalog below.
export type ILitmusReportProjectType = string
export type LitmusReportProjectType = (typeof LIT_REPORT_PROJECT_TYPES)[number]
export type SelectedStatusType = (typeof SELECTED_STATUS_TYPES)[number]
export type DateRangeType = (typeof DATE_RANGE_TYPES)[number]

// A user-added project type, scoped to the mode(s) it was added under (see report-metadata-form) —
// unlike the default catalog above, there's no UI to pick its modes directly.
export interface ILitmusCustomProjectType {
	label: string
	modes: string[]
}
